import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 全局数据源
import { ListStore } from '../../store';
// 接口
import { getRecommend } from '../../services';
import { getlocal } from '@src/utils';
import { message } from '@src/components/ModalBox';

// 端外分享
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import { Grounds } from '@ifeng-fe/client_grounds';

const Wrap = content => {
    const {
        account, // 自媒体账号
        dramaSeries, // 剧集
        positive, // 正片
        related, // 相关推荐
        crowd, // 合辑
        gags, // 花絮
        params, // id
        query, // 查询参数
    } = content.content;

    // 列表数据
    const useListStore = ListStore.useContainer();
    const { listStates, changeListStates } = useListStore;
    const { page } = listStates;
    // 自媒体账号
    const initAcount = () => {
        changeListStates({
            account,
        });
    };

    // 剧集信息
    const initDramaSeries = () => {
        changeListStates({
            dramaSeries,
        });
    };

    // 正片信息
    const initPositive = () => {
        const dataList = dramaSeries?.content?.dataList;

        dataList.forEach((item, index) => {
            if (item.extText) {
                positive[index]['extText'] = item.extText;
            }
        });

        changeListStates({
            positive: positive.filter(p => p.status !== 0),
        });
    };
    // 相关推荐信息
    const initRelationRecommend = () => {
        changeListStates({
            related,
        });
    };

    // 合辑信息
    const initCrowd = () => {
        changeListStates({
            crowd,
        });
    };

    // 花絮信息
    const initGags = () => {
        changeListStates({
            gagsList: gags,
        });
    };

    // 更多推荐列表
    const initRecommend = () => {
        getRecommend({ docId: dramaSeries.base62Id })
            .then(res => {
                const { data } = res;

                changeListStates({
                    recommond: data.items,
                    page: page + 1,
                });
            })
            .catch(err => {
                console.log('err', err);
            });
    };

    // 初始化视频
    const inintVideo = () => {
        const {
            source, // 来源
            positiveId, // 正片ID
            gagsId, // 花絮ID
        } = query;

        // 有查询参数
        if (source) {
            console.log('有查询参数');
            // 正片：url/剧集ID?正片ID = 1&来源 = positive（正片）
            if (source === 'positive' && positiveId) {
                const currentVideoIndex = positive.findIndex(item => item.base62Id === positiveId);

                if (currentVideoIndex > -1) {
                    console.log('播放指定');
                    changeListStates({
                        currentVideo: positive[currentVideoIndex],
                        gags: gags[currentVideoIndex],
                    });
                } else {
                    // 下线
                    message({
                        content: (
                            <div className={styles.success}>
                                <div className={styles.successText}>当前正片已下线</div>
                            </div>
                        ),
                    });
                    changeListStates({
                        currentVideo: positive[0],
                        gags: gags[0],
                    });

                    // 添加错误上报
                    const error = new Error('positiveOfflineSource');

                    if (window && window.BJ_REPORT) window.BJ_REPORT.report(error, false, 45);
                }
            } else if (source === 'gags' && gagsId) {
                gags.forEach((item, index) => {
                    const currentIndex = item.findIndex(i => i.base62Id === gagsId);

                    if (currentIndex > -1) {
                        console.log('正片数据', positive[index]);
                        console.log('花絮数据', item[currentIndex]);
                        console.log('花絮列表', gags[index]);
                        changeListStates({
                            currentVideo: item[currentIndex],
                            gags: gags[index],
                        });
                    }
                });
            } else {
                changeListStates({
                    currentVideo: positive[0],
                    gags: gags[0],
                });
            }
        } else {
            console.log('无查询参数');
            // 无查询参数
            const history = getlocal('history');

            // 本地有记录
            if (history) {
                // alert('本地有记录');
                const dramaSeries = history.find(item => item.id === params.id);

                // 有剧集记录
                if (dramaSeries) {
                    // alert('有剧集记录');
                    // alert('查询最近的播放记录');
                    const { videoSeries } = dramaSeries;

                    // 查询最近的播放记录
                    videoSeries.sort((a, b) => {
                        return a.createTime < b.createTime ? 1 : -1;
                    });

                    const newVideoId = videoSeries[0].id;

                    // alert(newVideoId);

                    const index = positive.findIndex(item => item.base62Id === newVideoId);

                    if (index > -1) {
                        changeListStates({
                            currentVideo: positive[index],
                            gags: gags[index],
                        });
                    } else {
                        changeListStates({
                            currentVideo: positive[0],
                            gags: gags[0],
                        });
                    }
                } else {
                    // alert('无剧集记录');
                    // alert(positive[0].videoPlayUrl);
                    changeListStates({
                        currentVideo: positive[0],
                        gags: gags[0],
                    });
                }
            } else {
                // alert('本地无记录');
                // 本地无记录
                changeListStates({
                    currentVideo: positive[0],
                    gags: gags[0],
                });
            }
        }
    };

    // 日夜间
    useEffect(() => {
        // ios：7440版本没有此方法需要单独判断适配
        if (window.grounds && !window.grounds.getShowMode && window.grounds.on) {
            // 首次判断是否处于夜间模式
            const nightMode = 'night';
            // 夜间模式变化的回调
            const showModeCallback = 'showModeCallback';

            window[showModeCallback] = current => {
                const isNightMode = current === nightMode;

                changeListStates({ isNightMode });
            };
            Grounds.on('theme', showModeCallback);
            // window.grounds.on('theme', showModeCallback);
        } else if (window.grounds && window.grounds.getShowMode && window.grounds.on) {
            // 首次判断是否处于夜间模式
            const nightMode = 'night';
            const isNightMode = window.grounds.getShowMode() === nightMode;

            changeListStates({ isNightMode });
            // 夜间模式变化的回调
            const showModeCallback = 'showModeCallback';

            window[showModeCallback] = current => {
                const isNightMode = current === nightMode;

                changeListStates({ isNightMode });
            };
            Grounds.on('theme', showModeCallback);
            // window.grounds.on('theme', showModeCallback);
        }
    }, []);

    useEffect(() => {
        // 初始化
        initAcount();
        initDramaSeries();
        initPositive();
        initRelationRecommend();
        initCrowd();
        initGags();
        initRecommend();
        // 初始化视频
        inintVideo();
    }, []);

    // 二次分享
    const qqShareCofig = {
        title: dramaSeries.title,
        img: dramaSeries.posterUrl,
        desc: dramaSeries.summary,
        url: `${window.location.href}`,
        cb: () => {
            console.log('分享成功');
        },
    };

    return (
        <React.Fragment>
            <div className={styles.wrap}>{content.children}</div>
            {qqShareCofig && qqShareCofig.title ? <QQShare content={qqShareCofig} /> : null}
        </React.Fragment>
    );
};

Wrap.propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    content: PropTypes.object,
};

export default errorBoundary(Wrap);
